/**
 * BugTransitionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugStateEntity } from "../BugStateEntity";
import { BugWorkflowEntity } from "../BugWorkflowEntity";
import { ProjectUserRole_TransitionsEntity } from "../ProjectUserRole_TransitionsEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { BugTransitionEntity } from "../BugTransitionEntity";
declare global {
    interface EntityTypeMap {
        BugTransition: BugTransitionEntity;
    }
}
export abstract class BugTransitionGeneratedEntity extends BaseEntity {
    public abstract bugTransitionId: string;
    public abstract templateId: string | null;
    public abstract equivBugTransition: number;
    public abstract name: string;
    public abstract nameDone: string;
    public abstract priority: number;
    public abstract autoActivation: number;
    public abstract startState: BugStateEntity | null;
    public abstract endState: BugStateEntity;
    public abstract bugWorkflow: BugWorkflowEntity;
    public abstract readonly rolesRelations: ReadonlyArray<ProjectUserRole_TransitionsEntity>;
    public abstract readonly bugNotes: ReadonlyArray<BugNoteEntity>;
}
